import XIcon from './x-icon.svg';
import ChevronDown from './chevron-down.svg';
import ChevronUp from './chevron-up.svg';
import CoverPhoto from './cover-photo.svg';
import LinkIcon from './link-icon.svg';
import AddLink from './add-link.svg';
import AddLinkDisabled from './add-link-disabled.svg';
import LinkedInIcon from './linkedin-icon.svg';
import ProfilePhoto from './profile-photo.svg';
import YoutubeIcon from './youtube-icon.svg';
import Avatar from './avatar.png';
import Kudos from './kudos.svg';
import Offsite from './offsite.svg';
import Groups from './groups.svg';
import TeamsIcon from './teams-icon.svg';
import Koala from './koala.svg';
import Frog from './frog.svg';
import Parrot from './parrot.svg';
import DangerTriangle from './danger-triangle.svg';
import NotFound from './not-found.svg';
import Padlock from './padlock_Light mode_spot.svg';
import CertificationBannerImage from './certification-banner-image.svg';
import Trophy from './trophy.svg';
import Rocket from './rocket.svg';
import Medal from './medal.svg';
import Document from './document.svg';

export {
  Padlock,
  XIcon,
  ChevronDown,
  ChevronUp,
  CoverPhoto,
  LinkIcon,
  AddLink,
  AddLinkDisabled,
  LinkedInIcon,
  ProfilePhoto,
  YoutubeIcon,
  Avatar,
  Kudos,
  Offsite,
  Groups,
  TeamsIcon,
  Koala,
  Frog,
  Parrot,
  DangerTriangle,
  NotFound,
  CertificationBannerImage,
  Trophy,
  Medal,
  Document,
  Rocket,
};
